'use client';

import {
  FrontendUserImpression,
  SaveUserImpressionRequest,
} from '@trucksmarter/shared';
import { makeClientSideRequest } from '@lib/api/client/http-client';
import Endpoint from '@lib/api/endpoints';

export default function saveUserImpression(payload: SaveUserImpressionRequest) {
  return makeClientSideRequest<
    SaveUserImpressionRequest,
    FrontendUserImpression
  >(Endpoint.UserImpressionSave, payload);
}
